import { Box } from "@chakra-ui/react";
import { Fragment } from "react";
import PlatformSelector from "../../components/GameComponents/PlatformSelector/PlatformSelector";
import Seo from "./seo";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import useCheckLogin from "../../hook/useCheckLogin";
import PlatformSelectorRight from "../../components/GameComponents/PlatformSelector/PlatformSelectorRight";
import useLongMachineSetting from "../../hook/useLongMachineSetting";

const Interest = ({ gameMainTypeFromProps } = {}) => {
  const { isMachineUser } = useCheckLogin();

  const { longMachineStickyTopConfig } = useLongMachineSetting();
  return (
    <Fragment>
      <Seo />
      <Box
        as="section"
        px="common-y"
        pb={{
          md: "home-space",
        }}
        display={{ base: "block", xl: "none" }}
        position="sticky"
        top={longMachineStickyTopConfig}
        bgColor="rgba(0,0,0,0.5)"
        zIndex={10}
      >
        <GameTypeSelector />
        <Box
          display={{
            base: "block",
            md: "none",
          }}
        >
          <PlatformSelector gameMainTypeFromProps={gameMainTypeFromProps} />
        </Box>
      </Box>

      <Box flex={1} display={{ base: "block", md: "flex" }}>
        <Box
          py="home-space"
          px="common-y"
          mb={{
            base: "60px",
            sm: "0px",
          }}
          w={{
            base: "100%",
            md: "calc(100% - 150px)",
          }}
        >
          <GameSelector gameMainTypeFromProps={gameMainTypeFromProps} />
        </Box>
        <Box
          display={{
            base: "none",
            md: "block",
          }}
          position="relative"
          zIndex={1000}
        >
          <PlatformSelectorRight
            gameMainTypeFromProps={gameMainTypeFromProps}
          />
        </Box>
      </Box>
    </Fragment>
  );
};

export default Interest;
